var React = require('react');

function ChevronDownInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"currentColor","strokeWidth":"2","d":"M57.44 19.736L32 44.264 6.56 19.736","fill":"none","strokeLinecap":"square","strokeLinejoin":"round"}));
}

ChevronDownInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = ChevronDownInline;

ChevronDownInline.default = ChevronDownInline;
